



































import { Authentication } from '@/auth/Authentication';
import { Inject } from 'vue-property-decorator';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Toolbar extends Vue {
  @Inject('authenticationService')
  private readonly authenticationService!: Authentication;

  private async logout() {
    await this.authenticationService.signOut();
    this.$router.replace('login');
  }
}
